import {Badge, Button, Stack, Typography} from '@mui/material';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import React from 'react';
/* eslint-disable react/prop-types */

export const CustomActionsColumn = ({filtersCount, visible, onClick}) =>
    (
        <Stack direction="column" gap={1} paddingBottom={visible ? 1 : 0}>
            <Typography variant="subtitle2" fontWeight={700}>Actions</Typography>
            {
                visible
                    ? <Badge badgeContent={filtersCount} color="primary">
                        <Button
                            size="small"
                            variant="outlined"
                            sx={{
                                textTransform: 'none',
                                color: '#186BBE',
                                border: ' solid 1px #186BBE'
                            }}
                            onClick={onClick}
                            startIcon={<FilterListRoundedIcon fontSize="small"/>}
                        >Apply filters</Button>
                    </Badge>
                    : ''
            }
        </Stack>
    );